import ElementDdExtension from './element-dd-extension'

declare module 'vue/types/vue' {
  export interface Vue {
    $messaging: ElementDdExtension
  }
}

export default {
  install(Vue: any) {
    Vue.prototype.$messaging = new ElementDdExtension(Vue.prototype.$message)
  },
}
